module.exports = __webpack_public_path__ + "static/media/background.e0598f3a.png";